var React = require('react');

function SearchClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.83481 5.8344C6.14724 5.52199 6.65377 5.522 6.96618 5.83443L16.0003 14.869L25.034 5.83613C25.3464 5.52373 25.8529 5.52375 26.1653 5.83618C26.4777 6.14862 26.4777 6.65515 26.1653 6.96755L17.1316 16.0004L26.1653 25.0344C26.4777 25.3469 26.4777 25.8534 26.1653 26.1658C25.8529 26.4782 25.3463 26.4782 25.0339 26.1658L16.0002 17.1317L6.96527 26.1658C6.65284 26.4782 6.1463 26.4782 5.8339 26.1658C5.52149 25.8533 5.52152 25.3468 5.83395 25.0344L14.8689 16.0003L5.83478 6.96577C5.52237 6.65334 5.52238 6.14681 5.83481 5.8344Z","fill":"#22202F"}));
}

SearchClose.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = SearchClose;

SearchClose.default = SearchClose;
